export default {
    CAPTCHA_PUBLIC_KEY: 'cdd06708-b95f-441c-9d12-148cb7855db8',
    BASE_API_KEY: 'b5007052-e751-4576-9c8f-224b62b34510',
    BASE_API_URL: 'https://web.spacenosgg.com:5013'
}